import Vue from 'vue'
import ElementDdExtension from './dd-extensions/element-dd-extension/index'

Vue.use(ElementDdExtension)
